/*
  Avyanna wishlist · one small script for hearts, header count, toast and the My Wishlist page.
  Guests: the list is kept in this browser (localStorage).
  Logged-in customers: the list is saved on their Shopify account through the Avyanna Wishlist app
  (app proxy /apps/avyanna-wishlist/wishlist), so it follows them to every device.
  A custom adapter can still be plugged in through window.AvWishlistConfig.adapter:
    adapter = { load(): Item[] | Promise<Item[]>, save(items): void | Promise }
    Item    = { h: product handle, id: product id, t: time saved }
*/
(function () {
  'use strict';
  if (window.AvWishlist) return;

  var C = window.AvWishlistConfig || {};
  var T = Object.assign({
    saved: 'Saved to your wishlist',
    removed: 'Removed from your wishlist',
    view: 'View',
    undo: 'Undo',
    save_label: 'Save to wishlist',
    remove_label: 'Remove from wishlist',
    saved_short: 'Saved',
    full: 'Your wishlist is full. Remove a piece to save a new one.'
  }, C.texts || {});
  var KEY = C.key || 'avyanna-wishlist-v1';
  var MAX = C.max || 100;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PAGE = C.page || ROOT + 'pages/wishlist';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.6-4.6-9.2-9.4C1.7 7.6 3.9 4.4 7.2 4.4c2 0 3.4 1.1 4.8 2.8 1.4-1.7 2.8-2.8 4.8-2.8 3.3 0 5.5 3.2 4.4 6.5-1.6 4.8-9.2 9.4-9.2 9.4z" stroke-linejoin="round"/></svg>';

  /* ---------- storage ---------- */
  function clean(v) {
    if (!Array.isArray(v)) return [];
    var seen = {};
    return v.filter(function (x) {
      if (!x || typeof x.h !== 'string' || !x.h || seen[x.h]) return false;
      seen[x.h] = 1; return true;
    }).slice(0, MAX);
  }
  var local = {
    load: function () { try { return clean(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch (e) { return []; } },
    save: function (items) { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} }
  };
  var adapter = C.adapter || null;

  /* Phase 2 · account sync. When a customer is logged in, the theme passes their saved list
     (customer metafield avyanna.wishlist) and the app proxy address. Changes are sent to the
     Avyanna Wishlist app, which saves them on the customer's account. */
  var acct = C.account && C.account.id ? C.account : null;
  var GUEST_KEY = KEY;
  var pushTimer = null, pushing = false, pending = false;
  function push(keepalive) {
    if (!acct) return;
    clearTimeout(pushTimer); pushTimer = null;
    if (pushing && !keepalive) { pending = true; return; }
    pushing = true; pending = false;
    fetch(acct.proxy, {
      method: 'POST', credentials: 'same-origin', keepalive: !!keepalive,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: list })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); })
      .catch(function () { pending = true; })
      .then(function () {
        pushing = false;
        if (pending) { pending = false; pushTimer = setTimeout(push, 3000); }
      });
  }
  function queuePush() { if (!acct) return; clearTimeout(pushTimer); pushTimer = setTimeout(push, 600); }

  var list;
  if (acct) {
    KEY = GUEST_KEY + '-c' + acct.id;
    var server = clean(acct.items);
    var guest = []; try { guest = clean(JSON.parse(localStorage.getItem(GUEST_KEY) || '[]')); } catch (e) {}
    var have = {}; server.forEach(function (x) { have[x.h] = 1; });
    var extra = guest.filter(function (x) { return !have[x.h]; });
    /* pieces saved as a guest join the account list, newest first */
    list = clean(extra.concat(server).sort(function (a, b) { return (b.t || 0) - (a.t || 0); }));
    try { localStorage.setItem(KEY, JSON.stringify(list)); localStorage.removeItem(GUEST_KEY); } catch (e) {}
    if (extra.length) queuePush();
  } else {
    list = local.load();
  }
  function persist() {
    local.save(list);
    queuePush();
    if (adapter && adapter.save) { try { Promise.resolve(adapter.save(list.slice())).catch(function () {}); } catch (e) {} }
  }
  /* send anything still waiting when the shopper leaves the page */
  window.addEventListener('pagehide', function () { if (pushTimer) push(true); });

  /* ---------- api ---------- */
  var subs = [];
  function idx(h) { for (var i = 0; i < list.length; i++) if (list[i].h === h) return i; return -1; }
  function changed(h, on, silent) {
    sync();
    var d = { items: list.slice(), handle: h, saved: on };
    subs.forEach(function (fn) { try { fn(d); } catch (e) {} });
    document.dispatchEvent(new CustomEvent('avyanna:wishlist', { detail: d }));
    if (!silent && h) toast(on, h);
  }
  var api = {
    has: function (h) { return idx(h) > -1; },
    list: function () { return list.slice(); },
    count: function () { return list.length; },
    add: function (h, id, silent) {
      if (!h || api.has(h)) return true;
      if (list.length >= MAX) { toastText(T.full); return false; }
      list.unshift({ h: h, id: Number(id) || 0, t: Date.now() });
      persist(); changed(h, true, silent); return true;
    },
    remove: function (h, silent) {
      var i = idx(h); if (i < 0) return;
      lastRemoved = { item: list[i], at: i };
      list.splice(i, 1); persist(); changed(h, false, silent);
    },
    toggle: function (h, id) { if (api.has(h)) { api.remove(h); return false; } return api.add(h, id); },
    on: function (fn) { subs.push(fn); },
    replace: function (items) { list = clean(items); local.save(list); changed(null, null, true); },
    pageUrl: PAGE
  };
  var lastRemoved = null;
  window.AvWishlist = api;

  /* Phase 2: let the account list load after the instant local one */
  if (adapter && adapter.load) {
    try {
      Promise.resolve(adapter.load()).then(function (items) { if (Array.isArray(items)) api.replace(items); }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- hearts + count ---------- */
  function sync(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-wl-handle]').forEach(function (b) {
      var on = api.has(b.getAttribute('data-wl-handle'));
      var name = b.getAttribute('data-wl-title') || '';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', (on ? T.remove_label : T.save_label) + (name ? ': ' + name : ''));
      var txt = b.querySelector('[data-wl-text]');
      if (txt) txt.textContent = on ? T.saved_short : T.save_label;
    });
    if (scope) return;
    document.querySelectorAll('[data-wl-count]').forEach(function (c) {
      var n = list.length;
      var t = c.querySelector('[data-wl-count-text]') || c; /* header uses the theme's own bubble markup */
      if (t.textContent !== String(n) && n > 0 && !c.hidden) { c.classList.remove('avwl-bump'); void c.offsetWidth; c.classList.add('avwl-bump'); }
      t.textContent = n > 99 ? '99+' : n; c.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wl-handle]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var on = api.toggle(b.getAttribute('data-wl-handle'), b.getAttribute('data-wl-id'));
    if (on) { b.classList.remove('avwl-pop'); void b.offsetWidth; b.classList.add('avwl-pop'); }
  }, true);

  /* cards added later (filters, infinite scroll, quick add) */
  var queued = false;
  new MutationObserver(function (records) {
    if (queued) return;
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.hasAttribute('data-wl-handle') || n.querySelector('[data-wl-handle]'))) {
          queued = true;
          requestAnimationFrame(function () { queued = false; sync(); });
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* back on this tab after using another device: pick up the latest account list */
  document.addEventListener('visibilitychange', function () {
    if (!acct || document.visibilityState !== 'visible' || pushTimer || pushing) return;
    fetch(acct.proxy, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.loggedIn || pushTimer || pushing) return;
        var fresh = clean(d.items);
        if (JSON.stringify(fresh) !== JSON.stringify(list)) api.replace(fresh);
      }).catch(function () {});
  });

  /* other tabs */
  window.addEventListener('storage', function (e) { if (e.key === KEY) { list = local.load(); changed(null, null, true); } });

  /* ---------- toast ---------- */
  var tEl, tTimer;
  function toastEl() {
    if (tEl) return tEl;
    tEl = document.createElement('div');
    tEl.className = 'avwl-toast';
    tEl.setAttribute('role', 'status');
    tEl.setAttribute('aria-live', 'polite');
    tEl.innerHTML = HEART + '<span data-t></span>';
    document.body.appendChild(tEl);
    return tEl;
  }
  function show(el, ms) {
    el.classList.add('is-on');
    clearTimeout(tTimer);
    tTimer = setTimeout(function () { el.classList.remove('is-on'); }, ms || 3200);
  }
  /* action (optional): { label, run } adds a small button to the toast, e.g. "View cart" */
  function toastText(text, ms, action) {
    var el = toastEl();
    el.querySelector('[data-t]').textContent = text;
    var a = el.querySelector('.avwl-toast-act'); if (a) a.remove();
    if (action && action.label) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'avwl-toast-act'; b.textContent = action.label;
      b.addEventListener('click', function () { el.classList.remove('is-on'); action.run(); });
      el.appendChild(b);
    }
    show(el, ms);
  }
  function toast(on, h) {
    var el = toastEl();
    el.querySelector('[data-t]').textContent = on ? T.saved : T.removed;
    var old = el.querySelector('.avwl-toast-act'); if (old) old.remove();
    var onPage = !!document.querySelector('[data-wl-page]');
    var act;
    if (on && !onPage) {
      act = document.createElement('a'); act.href = PAGE; act.textContent = T.view;
    } else if (!on && lastRemoved && lastRemoved.item.h === h) {
      act = document.createElement('button'); act.type = 'button'; act.textContent = T.undo;
      var keep = lastRemoved;
      act.addEventListener('click', function () {
        if (api.has(keep.item.h)) return;
        list.splice(Math.min(keep.at, list.length), 0, keep.item);
        persist(); changed(keep.item.h, true, true);
        el.classList.remove('is-on');
      });
    }
    if (act) { act.className = 'avwl-toast-act'; el.appendChild(act); }
    show(el);
  }

  /* ---------- add to cart (same events as Horizon's product form) ---------- */
  /* Shopify's cart events module: loaded once, ahead of the first click */
  var evReady = null;
  function events() { return evReady || (evReady = import('@shopify/events').catch(function () { return null; })); }

  /* One cart change at a time. Several adds sent at once can overtake each other: the cart drawer
     then redraws from an older answer and the count shows fewer pieces than the cart really holds. */
  var cartQueue = Promise.resolve();
  function enqueue(job) {
    var run = cartQueue.then(job, job);
    cartQueue = run.then(function () {}, function () {});
    return run;
  }

  /* A small section (sections/avyanna-cart-data.liquid) returns the whole cart inside the add
     response, so the cart is known after one request instead of two. */
  var CART_DATA = 'avyanna-cart-data';
  function cartFromSections(sections) {
    var html = sections && sections[CART_DATA];
    if (!html) return null;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector('[data-avyanna-cart]');
      var cart = el ? JSON.parse(el.textContent) : null;
      return cart && Array.isArray(cart.items) ? cart : null;
    } catch (e) { return null; }
  }
  /* Fallback: a fresh read of the cart. Never the theme's shared, possibly already-running read,
     which can answer with the cart from before this add finished. */
  function readCart(cartUrl) {
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('Cart ' + r.status); return r.json(); });
  }

  /* ---------- keep the cart on screen in step with the real cart ---------- */
  /* Horizon updates the cart drawer and the header count when it hears the cart event above.
     After every add we check that it really did. If not, we fill the drawer ourselves from
     fresh cart contents, so a shopper never needs to refresh the page to see what they added.
     Fresh means: the drawer that came back with the add itself, or a POST to the cart (a POST
     is never answered from a saved copy, unlike a normal page request). */
  var DEBUG = /[?&]wldebug\b/.test(location.search);
  var dbgEl = null;
  function dbg(msg) {
    if (!DEBUG) return;
    try { console.info('[wishlist cart]', msg); } catch (e) {}
    if (!dbgEl) {
      dbgEl = document.createElement('pre');
      dbgEl.style.cssText = 'position:fixed;left:8px;right:8px;top:8px;z-index:2147483647;max-height:40vh;overflow:auto;margin:0;padding:8px 10px;background:rgba(20,20,20,.88);color:#cfe;font:11px/1.45 monospace;white-space:pre-wrap;border-radius:8px;pointer-events:none';
      document.body.appendChild(dbgEl);
    }
    dbgEl.textContent += new Date().toLocaleTimeString() + '  ' + msg + '\n';
    dbgEl.scrollTop = dbgEl.scrollHeight;
  }
  function cartDrawer() { return document.querySelector('theme-drawer#cart-drawer'); }
  function drawerItems() { return document.querySelector('cart-items-component[data-drawer]'); }
  function drawerId() { var el = drawerItems(); return el && el.dataset.sectionId; }
  /* How many pieces a piece of drawer markup (or the live drawer) shows: 0 when it shows an empty cart */
  function shownCount(root) {
    if (!root) return -1;
    var c = root.querySelector('[ref="cartItemCount"]');
    if (c) return parseInt(c.textContent, 10) || 0;
    return root.querySelector('[data-cart-drawer-empty], .cart-drawer--empty') ? 0 : -1;
  }
  function drawerShows(cart) {
    var el = drawerItems();
    if (!el) return true; /* no cart drawer on this store setup: nothing to redraw */
    if (shownCount(el) !== (cart.item_count || 0)) return false;
    return (cart.items || []).every(function (it) { return !!el.querySelector('[data-key="' + CSS.escape(String(it.key)) + '"]'); });
  }
  function syncCount(n) {
    document.querySelectorAll('cart-icon').forEach(function (ic) {
      if (typeof ic.renderCartBubble === 'function' && ic.currentCartCount !== n) {
        try { ic.renderCartBubble(n, false); } catch (e) {}
      }
    });
  }
  var rendererReady = null;
  function renderer() { return rendererReady || (rendererReady = import('@theme/section-renderer').catch(function () { return null; })); }
  /* Puts drawer markup on the page: first the theme's own way, and if the drawer still shows
     something else, by swapping the drawer contents outright */
  function applyDrawer(html, cart) {
    var id = drawerId();
    if (!id || !html) return Promise.resolve(false);
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var want = cart ? (cart.item_count || 0) : shownCount(doc);
    if (shownCount(doc) !== want) { dbg('drawer markup shows ' + shownCount(doc) + ', cart has ' + want + ': not used'); return Promise.resolve(false); }
    var el = drawerItems();
    var wasEmpty = !!(el && el.querySelector('[data-cart-drawer-empty]'));
    return renderer().then(function (m) {
      if (m && m.morphSection) {
        try { if (m.sectionRenderer) m.sectionRenderer.abortRender(id); m.morphSection(id, html, { mode: 'hydration', injectStylesheet: wasEmpty }); }
        catch (e) { dbg('theme redraw failed: ' + e.message); }
      }
      var live = drawerItems();
      if (shownCount(live) !== want) {
        /* swap the inner part of the drawer (the theme keeps its drawer frame and listeners) */
        var fresh = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
        var old = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
        if (fresh && old) {
          old.replaceWith(document.importNode(fresh, true));
          var st = doc.querySelector('style[data-section-stylesheet]');
          var sec = document.getElementById('shopify-section-' + id);
          if (st && sec) {
            var cur = sec.querySelector('style[data-section-stylesheet]');
            if (cur) cur.textContent = st.textContent; else sec.prepend(document.importNode(st, true));
          }
          dbg('drawer contents swapped directly');
        }
      }
      document.querySelectorAll('cart-quantity-selector-component').forEach(function (s) { try { if (s.updateButtonStates) s.updateButtonStates(); } catch (e) {} });
      var ok = shownCount(drawerItems()) === want;
      dbg('drawer now shows ' + shownCount(drawerItems()) + ' (cart ' + want + ')');
      return ok;
    });
  }
  /* Fresh cart + fresh drawer in one request that is never served from a saved copy */
  function fetchFreshDrawer() {
    var id = drawerId();
    var routes = (window.Theme && Theme.routes) || {};
    var url = (routes.cart_update_url || ROOT + 'cart/update') + '.js';
    return fetch(url, {
      method: 'POST', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: {}, sections: id })
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (res) { return { cart: res, html: res && res.sections && res.sections[id] }; })
      .catch(function (e) {
        dbg('cart POST failed (' + e.message + '), trying a page request');
        var u = new URL(location.href); u.searchParams.set('section_id', id); u.searchParams.set('_wl', Date.now());
        return Promise.all([
          readCart((routes.cart_url || ROOT + 'cart')),
          fetch(u.toString(), { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.text(); })
        ]).then(function (a) { return { cart: a[0], html: a[1] }; });
      });
  }
  function refreshDrawer(why) {
    if (!drawerId()) return Promise.resolve();
    dbg('refreshing drawer: ' + why);
    return fetchFreshDrawer().then(function (f) {
      if (f.cart && typeof f.cart.item_count === 'number') { lastCart = f.cart; syncCount(f.cart.item_count); }
      return applyDrawer(f.html, f.cart);
    }).catch(function (e) { dbg('refresh failed: ' + e.message); });
  }
  var lastCart = null;
  /* After an add: give the theme a moment, then use the drawer from the add answer, then a fresh one */
  function syncCart(cart, addHtml) {
    if (!cart || !Array.isArray(cart.items)) return Promise.resolve();
    lastCart = cart;
    syncCount(cart.item_count);
    dbg('added; cart has ' + cart.item_count + '; drawer markup in add answer: ' + (addHtml ? 'yes, shows ' + shownCount(new DOMParser().parseFromString(addHtml, 'text/html')) : 'no'));
    return new Promise(function (done) { setTimeout(done, 150); }).then(function () {
      if (drawerShows(cart)) { dbg('theme updated the drawer'); return true; }
      return applyDrawer(addHtml, cart);
    }).then(function (ok) {
      if (ok && drawerShows(cart)) return;
      return refreshDrawer('drawer still out of date');
    }).then(function () { syncCount(lastCart ? lastCart.item_count : cart.item_count); });
  }
  function openCartDrawer() {
    var dr = cartDrawer();
    if (dr && typeof dr.open === 'function') { if (!dr.isOpen) dr.open(); return true; }
    return false;
  }
  api.openCart = openCartDrawer;
  /* Safety net on the wishlist page: whenever the cart drawer opens, make sure it shows the real cart */
  document.addEventListener('theme-drawer:open', function (e) {
    if (!e.target || e.target.id !== 'cart-drawer' || !document.querySelector('[data-wl-page]')) return;
    setTimeout(function () {
      if (lastCart && drawerShows(lastCart)) return;
      refreshDrawer(lastCart ? 'opened, out of date' : 'opened, checking');
    }, 60);
  });

  /* Adds lines to the cart one by one (inside the queue) and reports each result:
     resolves with { results: [{ line, ok, reason }], added, cart }.
     One cart event is sent for the whole set, the way Horizon's own product form does it,
     so the drawer and the header count update once, from the final cart. */
  function cartAddEach(items, source) {
    return enqueue(function () {
      var routes = (window.Theme && Theme.routes) || {};
      var addUrl = routes.cart_add_url || ROOT + 'cart/add.js';
      var cartUrl = routes.cart_url || ROOT + 'cart';
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) < 0) ids.push(el.dataset.sectionId); });
      ids.push(CART_DATA);
      /* Send the cart events from the tapped button while it is still on the page. If the list was
         redrawn in the meantime (e.g. the account list refreshed), send them from the page instead,
         so the cart drawer and the header count still hear them. */
      function target() {
        if (source && source.isConnected) return source;
        return document.querySelector('[data-wl-page]') || document;
      }

      return events().then(function (ev) {
        var deferred = null;
        if (ev && ev.CartLinesUpdateEvent) {
          deferred = ev.CartLinesUpdateEvent.createPromise();
          target().dispatchEvent(new ev.CartLinesUpdateEvent({
            action: 'add', context: 'product',
            lines: items.map(function (x) { return { merchandiseId: String(x.id), quantity: x.quantity }; }),
            promise: deferred.promise
          }));
        }
        var results = [], lastSections = null, added = 0;
        function addOne(line) {
          return fetch(addUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: line.id, quantity: line.quantity }], sections: ids.join(',') })
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res && res.status) {
              results.push({ line: line, ok: false, reason: res.description || res.message || '' });
              if (ev && ev.CartErrorEvent) {
                target().dispatchEvent(new ev.CartErrorEvent({ error: res.message || 'Add to cart failed', code: 'INVALID', detail: { description: res.description, errors: res.errors } }));
              }
            } else {
              results.push({ line: line, ok: true });
              added += line.quantity;
              if (res && res.sections) lastSections = res.sections;
            }
          }, function () {
            results.push({ line: line, ok: false, reason: '', network: true });
          });
        }
        var chain = Promise.resolve();
        items.forEach(function (line) { chain = chain.then(function () { return addOne(line); }); });

        return chain.then(function () {
          var cart = cartFromSections(lastSections);
          return cart ? cart : readCart(cartUrl);
        }).then(function (cart) {
          /* if the quick cart answer can't be read for any reason, read the cart the normal way */
          try { if (ev && ev.CartLinesUpdateEvent) ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart); return cart; }
          catch (e) { return readCart(cartUrl); }
        }).then(function (cart) {
          var anyOk = added > 0;
          if (deferred) {
            var sections;
            if (anyOk && lastSections) {
              sections = {};
              Object.keys(lastSections).forEach(function (k) { if (k !== CART_DATA) sections[k] = lastSections[k]; });
            }
            deferred.resolve({
              cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, source: 'avyanna-wishlist', sourceId: 'avyanna-wishlist', itemCount: added, sections: sections, didError: !anyOk }
            });
          }
          var out = { results: results, added: added, cart: cart };
          /* Make sure the drawer and the count really show this cart before reporting back */
          return (anyOk ? syncCart(cart, lastSections && lastSections[drawerId()]) : Promise.resolve()).then(function () { return out; });
        }, function (err) {
          if (deferred) deferred.reject(err);
          if (!added) throw err;
          /* The pieces went in but the new cart couldn't be read: redraw the drawer from the
             server and take the count from it, then report what was added */
          return refreshDrawer('added, but the new cart could not be read').then(function () {
            return { results: results, added: added, cart: lastCart };
          });
        });
      });
    });
  }

  /* Single add (kept for anything that already calls AvWishlist.addToCart): rejects with the reason on failure */
  function cartAdd(items, source) {
    return cartAddEach(items, source).then(function (out) {
      var bad = out.results.filter(function (r) { return !r.ok; });
      if (bad.length && !out.added) throw new Error(bad[0].reason || '');
      return out.cart;
    });
  }

  /* Horizon's "fly to cart" picture, when Theme settings → Add to cart animation is on */
  function flyToCart(from, image) {
    var dest = document.querySelector('.header-actions__cart-icon');
    if (!from || !image || !dest || !customElements.get('fly-to-cart')) return;
    var f = document.createElement('fly-to-cart');
    f.classList.add('fly-to-cart--quick');
    f.style.setProperty('background-image', 'url(' + image + ')');
    f.style.setProperty('--start-opacity', '0');
    f.source = from;
    f.destination = dest;
    document.body.appendChild(f);
  }
  api.addToCart = cartAdd;
  api.addToCartEach = cartAddEach;

  /* ---------- My Wishlist page ---------- */
  function initPage(page) {
    var d = page.dataset;
    var grid = page.querySelector('[data-wl-grid]');
    var empty = page.querySelector('[data-wl-empty]');
    var sub = page.querySelector('[data-wl-sub]');
    var bar = page.querySelectorAll('[data-wl-when-items]');
    var allBtn = page.querySelector('[data-wl-all]');
    var loading = page.querySelector('[data-wl-loading]');
    var cache = {};

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function money(cents) {
      var fmt = d.money || '₹{{amount}}';
      var n = (Number(cents) || 0) / 100;
      function f(dec, th, de) {
        var parts = n.toFixed(dec).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
        return parts[1] ? parts[0] + de + parts[1] : parts[0];
      }
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        if (k === 'amount_no_decimals') return f(0, ',', '.');
        if (k === 'amount_with_comma_separator') return f(2, '.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return f(0, '.', ',');
        if (k === 'amount_with_apostrophe_separator') return f(2, "'", '.');
        if (k === 'amount_no_decimals_with_space_separator') return f(0, ' ', '.');
        if (k === 'amount_with_space_separator') return f(2, ' ', ',');
        return f(2, ',', '.');
      });
    }
    function img(src, alt, cls, eager) {
      if (!src) return '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      var j = src.indexOf('?') > -1 ? '&' : '?';
      var set = [240, 360, 480, 600, 800].map(function (w) { return src + j + 'width=' + w + ' ' + w + 'w'; }).join(', ');
      return '<img class="' + cls + '" src="' + esc(src + j + 'width=600') + '" srcset="' + esc(set) + '" sizes="(min-width:1600px) 300px, (min-width:990px) 19vw, (min-width:750px) 31vw, 46vw" width="600" height="600" alt="' + esc(alt) + '"' + (eager ? '' : ' loading="lazy"') + ' decoding="async">';
    }
    function thumb(src) {
      if (!src) return '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=100';
    }
    var PLUS = '<svg class="plus" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" fill="none"/></svg>';
    var OK = '<svg class="ok" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';
    /* Pre-order: tag starting with "pre-order" in any spelling ("Pre-Order | Take a Note", "Pre - Order | ...") */
    function preKey(t) { return String(t || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
    function isPre(tags) {
      var k = preKey(d.preorderTag);
      if (!k) return false;
      return (tags || []).some(function (t) { return preKey(t).indexOf(k) === 0; });
    }
    function card(p, i) {
      var pre = isPre(p.tags);
      /* New and Sale: same rules as the collection page (tag "new"; compare-at on the cheapest available option) */
      var nt = String(d.newTag || '').toLowerCase().trim();
      var isNew = !!nt && (p.tags || []).some(function (t) { return String(t).toLowerCase().trim() === nt; });
      var cv = (p.variants || []).filter(function (x) { return x.available; }).sort(function (a, b) { return a.price - b.price; })[0] || (p.variants || [])[0];
      var sale = p.compare_at_price && p.compare_at_price > p.price;
      var saleTag = !!(cv && cv.compare_at_price && cv.compare_at_price > cv.price);
      var many = p.variants && p.variants.length > 1;
      var v = (p.variants || []).filter(function (x) { return x.available; })[0];
      var badge = !p.available ? '<span class="avwl-badge avwl-badge--sold">' + esc(d.tSoldout) + '</span>'
        : pre ? '<span class="avwl-badge avwl-badge--pre">' + esc(d.tPreorder) + '</span>'
        : saleTag ? '<span class="avwl-badge avwl-badge--sale">' + esc(d.tSale) + '</span>'
        : isNew && d.tNew ? '<span class="avwl-badge avwl-badge--new">' + esc(d.tNew) + '</span>' : '';
      var price = (p.price_varies ? '<span class="avwl-from">' + esc(d.tFrom) + '&nbsp;</span>' : '') +
        (sale ? '<span class="avwl-sr">' + esc(d.tRegular) + '</span><s>' + esc(money(p.compare_at_price)) + '</s><span class="avwl-sr">' + esc(d.tSaleprice) + '</span><span class="is-sale">' + esc(money(p.price)) + '</span>' : esc(money(p.price)));
      var second = d.swap === 'true' && p.images && p.images[1] ? img(p.images[1], '', 'avwl-sec', false).replace(' alt=""', ' alt="" aria-hidden="true"') : '';
      var qa = '';
      if (p.available && v) {
        qa = many
          ? '<a class="avwl-qa" href="' + esc(p.url) + '" aria-label="' + esc(d.tChoose + ': ' + p.title) + '">' + PLUS + '</a>'
          : '<button class="avwl-qa" type="button" data-wl-add="' + v.id + '" data-wl-img="' + esc(thumb(p.featured_image)) + '" aria-label="' + esc(d.tAdd + ': ' + p.title) + '">' + PLUS + OK + '</button>';
      }
      return '<li data-wl-item="' + esc(p.handle) + '"><div class="avwl-card' + (p.available ? '' : ' is-sold') + '">' +
        '<div class="avwl-img"><a class="avwl-media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img(p.featured_image, p.title, 'avwl-pri', i < 5) + second + '</a>' +
        badge +
        '<button class="avwl-heart avwl-heart--card" type="button" data-wl-handle="' + esc(p.handle) + '" data-wl-id="' + p.id + '" data-wl-title="' + esc(p.title) + '" aria-pressed="true">' + HEART + '</button>' +
        qa + '</div>' +
        '<a class="avwl-link" href="' + esc(p.url) + '"><span class="avwl-brand">' + (d.vendor === 'true' && p.vendor ? esc(p.vendor) : '') + '</span>' +
        '<h2 class="avwl-name">' + esc(p.title) + '</h2>' +
        '<p class="avwl-price">' + price + '</p></a></div></li>';
    }
    function fetchOne(h) {
      if (cache[h] !== undefined) return Promise.resolve(cache[h]);
      return fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return undefined; })
        .then(function (p) { if (p !== undefined) cache[h] = p; return p; });
    }
    var cntEl = page.querySelector('[data-wl-cnt]');
    var vendors = {};
    function state(n) {
      if (loading) loading.hidden = true;
      empty.hidden = n > 0;
      grid.hidden = n === 0;
      bar.forEach(function (el) { el.hidden = n === 0; });
      var studios = {};
      grid.querySelectorAll('[data-wl-item]').forEach(function (li) { var v = vendors[li.getAttribute('data-wl-item')]; if (v) studios[v] = 1; });
      var sc = Object.keys(studios).length;
      if (sub) sub.textContent = n ? n + ' ' + (n === 1 ? d.tOne : d.tMany) + (sc ? ' · ' + sc + ' ' + (sc === 1 ? d.tStudio : d.tStudios) : '') : '';
      if (cntEl) cntEl.textContent = n ? (d.tItems || '[count] items').replace('[count]', n) : '';
      if (allBtn) {
        var addable = grid.querySelectorAll('[data-wl-add]').length;
        allBtn.hidden = !addable;
        /* Say up front when "Add all" can't cover every piece (pieces with options or sold out) */
        var lbl = allBtn.querySelector('span') || allBtn;
        if (!allBtn.disabled) {
          if (!allBtn.dataset.allText) allBtn.dataset.allText = lbl.textContent;
          lbl.textContent = addable && addable < n && d.tAddcount ? d.tAddcount.replace('[count]', addable) : allBtn.dataset.allText;
        }
      }
    }
    function render() {
      var items = api.list();
      if (!items.length) { grid.innerHTML = ''; state(0); return; }
      Promise.all(items.map(function (x) { return fetchOne(x.h); })).then(function (ps) {
        var gone = [];
        var html = ps.map(function (p, i) {
          if (p === null) { gone.push(items[i].h); return ''; } /* product deleted or unpublished */
          if (p) vendors[p.handle] = p.vendor || '';
          return p ? card(p, i) : '';
        }).join('');
        gone.forEach(function (h) { api.remove(h, true); });
        grid.innerHTML = html;
        state(grid.children.length);
        sync(grid);
      });
    }

    api.on(function (dt) {
      if (dt.saved === false && dt.handle) {
        var li = grid.querySelector('[data-wl-item="' + CSS.escape(dt.handle) + '"]');
        if (li) {
          li.classList.add('is-leaving');
          setTimeout(function () { li.remove(); state(grid.children.length); }, 220);
          return;
        }
      }
      render();
    });

    function fill(t, n) { return String(t || '').replace('[count]', n); }
    /* When to open the cart drawer after adding (section setting): each | all | never */
    var openMode = d.openCart || 'each';
    var viewCart = d.tViewcart ? { label: d.tViewcart, run: function () {
      if (!openCartDrawer()) window.location.href = ((window.Theme && Theme.routes && Theme.routes.cart_url) || ROOT + 'cart');
    } } : null;
    function reasonText(r) { return r && r.reason ? r.reason : d.tError; }

    page.addEventListener('click', function (e) {
      var one = e.target.closest('[data-wl-add]');
      if (one) {
        e.preventDefault();
        if (one.classList.contains('is-busy') || one.classList.contains('is-added')) return;
        /* Busy until Shopify confirms; the tick only shows once the piece is really in the cart */
        one.classList.add('is-busy');
        one.setAttribute('aria-busy', 'true');
        if (d.fly === 'true') flyToCart(one, one.getAttribute('data-wl-img'));
        cartAddEach([{ id: Number(one.getAttribute('data-wl-add')), quantity: 1 }], one).then(function (out) {
          one.classList.remove('is-busy'); one.removeAttribute('aria-busy');
          var r = out.results[0];
          if (r && r.ok) {
            one.classList.add('is-added');
            setTimeout(function () { one.classList.remove('is-added'); }, 1600);
            /* Show the cart, with the piece already in it, like a normal add to cart */
            if (openMode === 'each') openCartDrawer();
          } else {
            toastText(reasonText(r), 5000);
          }
        }).catch(function () {
          one.classList.remove('is-busy'); one.removeAttribute('aria-busy');
          toastText(d.tError, 5000);
        });
        return;
      }
      if (allBtn && e.target.closest('[data-wl-all]')) {
        if (allBtn.disabled) return;
        var btns = [].slice.call(grid.querySelectorAll('[data-wl-add]'));
        if (!btns.length) return;
        var choose = [].slice.call(grid.querySelectorAll('a.avwl-qa'));
        var lbl = allBtn.querySelector('span') || allBtn;
        var was = lbl.textContent;
        allBtn.disabled = true; allBtn.setAttribute('aria-busy', 'true'); lbl.textContent = d.tAdding;
        btns.forEach(function (b) { b.classList.add('is-busy'); });

        /* Check availability again right before adding: the page may have been open a while */
        var checks = btns.map(function (b) {
          var li = b.closest('[data-wl-item]');
          var h = li ? li.getAttribute('data-wl-item') : '';
          return fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return undefined; })
            .then(function (p) {
              if (p === undefined) return { b: b, h: h, ok: true }; /* couldn't check: let the cart decide */
              if (p) cache[h] = p;
              var v = p && (p.variants || []).filter(function (x) { return String(x.id) === b.getAttribute('data-wl-add'); })[0];
              return { b: b, h: h, ok: !!(p && p.available && v && v.available), title: p ? p.title : h };
            });
        });

        Promise.all(checks).then(function (list) {
          var go = list.filter(function (x) { return x.ok; });
          var gone = list.filter(function (x) { return !x.ok; });
          var lines = go.map(function (x) { return { id: Number(x.b.getAttribute('data-wl-add')), quantity: 1 }; });
          var run = lines.length ? cartAddEach(lines, allBtn) : Promise.resolve({ results: [], added: 0 });
          return run.then(function (out) {
            var ok = 0, failed = [];
            out.results.forEach(function (r, i) {
              var b = go[i] && go[i].b;
              if (b) b.classList.remove('is-busy');
              if (r.ok) { ok++; if (b) { b.classList.add('is-added'); (function (bb) { setTimeout(function () { bb.classList.remove('is-added'); }, 1600); })(b); } }
              else failed.push({ ok: false, reason: r.reason, title: go[i] && go[i].title });
            });
            gone.forEach(function (x) { x.b.classList.remove('is-busy'); failed.push({ ok: false, reason: '' , soldout: true, title: x.title }); });
            /* Pieces with options can't be added without a choice: point them out */
            choose.forEach(function (a) {
              a.classList.remove('is-flag'); void a.offsetWidth; a.classList.add('is-flag');
              setTimeout(function () { a.classList.remove('is-flag'); }, 4000);
            });
            var parts = [];
            if (ok) parts.push(fill(d.tSumadded, ok));
            if (failed.length === 1) parts.push(failed[0].soldout ? String(d.tSumsold || '').replace('[name]', failed[0].title || '') : reasonText(failed[0]));
            else if (failed.length > 1) parts.push(fill(d.tSumfailed, failed.length) + ': ' + failed.map(function (f) { return f.title; }).filter(Boolean).join(', '));
            if (choose.length) parts.push(fill(d.tSumchoose, choose.length));
            lbl.textContent = ok ? d.tAdded : was;
            /* Everything went in: show the cart. Something needs attention: show the summary
               (the drawer would cover it on phones) with a "View cart" button instead. */
            var opened = ok && !failed.length && !choose.length && openMode !== 'never' && openCartDrawer();
            if (!opened) toastText(parts.join(' · ') || d.tError, failed.length || choose.length ? 7000 : 3600, ok ? viewCart : null);
            if (gone.length) { gone.forEach(function (x) { delete cache[x.h]; }); }
            setTimeout(function () {
              allBtn.disabled = false; allBtn.removeAttribute('aria-busy');
              lbl.textContent = was;
              if (gone.length) render(); else state(grid.children.length);
            }, ok ? 1800 : 0);
          });
        }).catch(function () {
          btns.forEach(function (b) { b.classList.remove('is-busy'); });
          lbl.textContent = was; allBtn.disabled = false; allBtn.removeAttribute('aria-busy');
          toastText(d.tError, 5000);
        });
      }
    });

    render();
  }

  function boot() {
    sync();
    var page = document.querySelector('[data-wl-page]');
    if (page) { events(); initPage(page); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
